export default __webpack_public_path__ + "static/gold_tier-84b435b49228a51535ea58fcc8cba976.png";